export default {"src":"https://images-cdn-staging.curipod.com/d-684a0051/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};